import wlus from './initial/wlus';
import wlusArchived from './initial/archived/wlus-archived';
import wlusmonthly from './monthly/wlusmonthly';
import wlusAltOnlyQuestions from './AlternativeOnlyInitial/questions';
import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { SlendidWeightlossQuestions } from './Slendid/questions';

const weightlossQuestions = [
  ...wlus,
  ...wlusArchived,
  ...wlusmonthly,
  ...wlusAltOnlyQuestions
];
const _type = [...weightlossQuestions] as const;

export type WeightLossFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default [...weightlossQuestions, ...SlendidWeightlossQuestions];
